import React from 'react';
import DataGrid from '../../../../table/DataGrid';

const PhotoManagementTable = ({
  list,
  isLoadingList,
  columns,
  totalList,
  skip,
  rowsPerPage,
}) => {
  return (
      <DataGrid
        id='PhotoManagement'
        rows={list}
        loading={isLoadingList}
        rowsPerPage={rowsPerPage}
        totalRows={totalList}
        skip={skip}
        columns={columns}
        nameModule='photo-management'
        labelNoRows="You don't have any photo yet"
      />
  );
};

export default PhotoManagementTable;
